"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleImage = void 0;
var bbox_1 = require("./bbox");
function scaleImage(extent, _a) {
    var _b = _a === void 0 ? {
        checkExtent: true,
        resolution: 256,
        maxPixels: 5096,
    } : _a, _c = _b.checkExtent, doCheckExtent = _c === void 0 ? true : _c, _d = _b.resolution, resolution = _d === void 0 ? 256 : _d, _e = _b.maxPixels, maxPixels = _e === void 0 ? 5096 : _e;
    if (doCheckExtent) {
        (0, bbox_1.checkExtent)(extent);
    }
    var _f = __read(extent, 4), minX = _f[0], minY = _f[1], maxX = _f[2], maxY = _f[3];
    // Get our image width & height at either the desired resolution or a down-sampled resolution if the resulting
    // dimensions would exceed our `maxPixels` in height or width
    var xRange = maxX - minX;
    var yRange = maxY - minY;
    var maxDim = Math.min(maxPixels, xRange * resolution, yRange * resolution);
    var scale = maxDim / Math.max(xRange, yRange);
    var width = Math.ceil(xRange * scale);
    var height = Math.ceil(yRange * scale);
    return { width: width, height: height };
}
exports.scaleImage = scaleImage;
